/**
 *
 * 视角飞行
 *
 * 功能点:视角飞行
 * 场景:方案演示
 * 版本 1.0
 *
 */
import Vue from "@/main";

export function flight(coordinate, id, fn) {
  console.log(coordinate);
  if (typeof coordinate == "string") {
    coordinate = JSON.parse(coordinate);
  }
  Vue.$GLOBAL.map.centerAt(
    { ...coordinate },
    {
      complete: () => {
        if (fn) fn();
      },
    }
  );
}
